import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';

@Component({
    selector: 'app-arcgis-login-response',
    templateUrl: './arcgis-login-response.html',
})
export class ArcGISLoginResponseComponent implements OnInit {

    public userAuthCodeOrToken: string = '';
    public isReady: boolean = false;

    constructor(
        private activatedRoute: ActivatedRoute
    ) {}

    ngOnInit(): void {
        // If the login dialog returns an authorization code, it will be passed as a query parameter.
        // If the login dialog returns a token, it will be passed as a hash fragment in the URL.
        this.activatedRoute.queryParamMap
        .subscribe((params: ParamMap) => {
            const code = params.get('code');

            this.userAuthCodeOrToken = code || null;
            this.isReady = true;

            window.location.href = window.location.href.replace(/\?.*/, '');

            if (window.opener && window.opener.oauthCallback) {
                window.opener.oauthCallback(this.userAuthCodeOrToken, false);
            }
        }).unsubscribe();
    }
}
